import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography, Box, Button, Hidden } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { ReactComponent as ShapeMobileSVG } from './assets/shape_mobile.svg';
import { ReactComponent as ShapeDesktopSVG } from './assets/shape_desktop.svg';
import mentorBanner from './assets/banner1200.webp';
import mentorBannerFallback from './assets/banner1200.png';
import { useStyles } from './styles';

interface MentorsBannerProps {
  size?: 'small' | 'default';
}

const MentorsBanner = ({ size = 'default' }: MentorsBannerProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);
  const classes = useStyles({ hover, size });

  const openMentors = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    history.push('/mentors');
  };

  const onMouseEnter = () => {
    setHover(true);
  };

  const onMouseLeave = () => {
    setHover(false);
  };

  return (
    <Box
      onClick={openMentors}
      className={clsx(classes.root, size === 'small' && classes.squareBanner)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <picture>
        <source srcSet={mentorBanner} type="image/webp" />
        <source srcSet={mentorBannerFallback} type="image/png" />
        <img src={mentorBanner} alt="mentor" className={classes.mentorImage} />
      </picture>

      <ShapeMobileSVG className={classes.mentorShape} />

      {size === 'default' && (
        <Hidden mdDown>
          <ShapeDesktopSVG className={classes.mentorShape} />
        </Hidden>
      )}

      <Box className={classes.info}>
        <Typography variant="h4" className={classes.infoLabel}>
          {t('v2.dashboard.individualCalls_banner_label_title')}.
        </Typography>
        <Button
          id="cta_mentor_banner"
          variant="contained"
          color="secondary"
          className={classes.cardButton}
          onClick={openMentors}
        >
          {t('v2.dashboard.section_discoverOurMentors_banner_cta_label')}
        </Button>
      </Box>
    </Box>
  );
};

export default MentorsBanner;
